import React, { useEffect, useState } from "react";
import MonacoEditor, { loader } from "@monaco-editor/react";
import iPlastic from "monaco-themes/themes/iPlastic.json";

const CodeEditor = ({
  language = "json",
  value = "",
  onChange = () => {}, // Handles editing
  selectedTheme = "iplastic", // Default theme
  height = "30rem",
  width = "55rem",
  showMinimap = false,
  readOnly = false, // Toggle editor/viewer mode (accepts string or boolean)
}) => {
  const [themeLoaded, setThemeLoaded] = useState(false);
  const isMinimapEnabled = showMinimap === true || showMinimap === "true";

  // Convert string "true"/"false" to boolean
  const isReadOnly = readOnly === true || readOnly === "true";

  const availableThemes = {
    iplastic: iPlastic,
    "vs-dark": "vs-dark",
    "vs-light": "vs",
    "hc-black": "hc-black",
  };

  useEffect(() => {
    loader.init().then((monaco) => {
      // Define iPlastic theme every time (safe way to ensure it exists)
      monaco.editor.defineTheme("iplastic", iPlastic);
      setThemeLoaded(true);
    });
  }, []);

  return (
    <div style={{ height, width, border: "1px solid #ccc" }}>
      {themeLoaded && (
        <MonacoEditor
          height="40rem"
          width="100%"
          language={language}
          theme={availableThemes[selectedTheme] ? selectedTheme : "vs-dark"}
          value={value}
          onChange={onChange}
          options={{
            readOnly: isReadOnly,
            minimap: { enabled: isMinimapEnabled },
            scrollBeyondLastLine: false,
            wordWrap: "off",
          }}
        />
      )}
    </div>
  );
};

export default CodeEditor;
